import React, { useState } from 'react';
import Hero from '../components/Hero';
import { useLanguage } from '../context/LanguageContext';
import { Mail, Phone, MapPin, Send, MessageSquare, Clock } from 'lucide-react';
import './Contact.css';

const Contact = () => {
    const { t } = useLanguage();

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: 'General Inquiry',
        message: ''
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setTimeout(() => {
            setIsSubmitting(false);
            setSubmitted(true);
            setFormData({ name: '', email: '', phone: '', subject: 'General Inquiry', message: '' });
        }, 1500);
    };

    return (
        <div className="contact-page">
            <Hero
                title={t('contact_hero_title')}
                subtitle={t('contact_hero_subtitle')}
                bgGradient={true}
                image="/assets/contact-hero.png"
                imageAlt="Contact support illustration"
            />

            <section className="section-padding container">
                <div className="contact-grid">
                    {/* Contact Information */}
                    <div className="contact-info">
                        <h2 className="section-title">{t('contact_title')}</h2>
                        <p className="section-subtitle">{t('contact_subtitle')}</p>

                        <div className="info-cards">
                            <div className="info-item">
                                <div className="info-icon"><Mail size={24} /></div>
                                <div className="info-text">
                                    <h3>{t('contact_email_title')}</h3>
                                    <p>support@insurewise.com</p>
                                    <p>claims@insurewise.com</p>
                                </div>
                            </div>

                            <div className="info-item">
                                <div className="info-icon"><Phone size={24} /></div>
                                <div className="info-text">
                                    <h3>{t('contact_call_title')}</h3>
                                    <p>+91 11 4000 5000</p>
                                    <p>{t('contact_hours_mf')}: 9am - 6pm</p>
                                </div>
                            </div>

                            <div className="info-item">
                                <div className="info-icon"><MapPin size={24} /></div>
                                <div className="info-text">
                                    <h3>{t('contact_visit_title')}</h3>
                                    <p>123 Finance Plaza, Wall Street</p>
                                    <p>New York, NY 10005</p>
                                </div>
                            </div>
                        </div>

                        <div className="office-hours">
                            <div className="hours-header">
                                <Clock size={20} />
                                <h3>{t('contact_hours_title')}</h3>
                            </div>
                            <ul>
                                <li><span>{t('contact_hours_mf')}</span> <span>{t('contact_hours_mf_time')}</span></li>
                                <li><span>{t('contact_hours_sat')}</span> <span>{t('contact_hours_sat_time')}</span></li>
                                <li><span>{t('contact_hours_sun')}</span> <span>{t('contact_hours_sun_time')}</span></li>
                            </ul>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="contact-form-container">
                        {submitted ? (
                            <div className="success-message fade-in">
                                <div className="success-icon"><Send size={48} /></div>
                                <h2>{t('contact_success_title')}</h2>
                                <p>{t('contact_success_text')}</p>
                                <button className="btn btn-primary" onClick={() => setSubmitted(false)}>{t('contact_success_btn')}</button>
                            </div>
                        ) : (
                            <form className="contact-form" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="name">{t('contact_form_name')}</label>
                                    <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder={t('contact_form_placeholder_name')} required />
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="email">{t('contact_form_email')}</label>
                                        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder={t('contact_form_placeholder_email')} required />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="phone">{t('contact_form_phone')}</label>
                                        <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} placeholder={t('contact_form_placeholder_phone')} />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="subject">{t('contact_form_subject')}</label>
                                    <select id="subject" name="subject" value={formData.subject} onChange={handleChange}>
                                        <option value="General Inquiry">{t('contact_option_general')}</option>
                                        <option value="Claims Support">{t('contact_option_claims')}</option>
                                        <option value="Agent Consultation">{t('contact_option_agent')}</option>
                                        <option value="Policy Update">{t('contact_option_policy')}</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="message">{t('contact_form_message')}</label>
                                    <textarea id="message" name="message" rows="5" value={formData.message} onChange={handleChange} placeholder={t('contact_form_placeholder_message')} required></textarea>
                                </div>

                                <button type="submit" className={`btn btn-primary btn-block ${isSubmitting ? 'loading' : ''}`} disabled={isSubmitting}>
                                    {isSubmitting ? t('contact_form_sending') : t('contact_form_submit')}
                                    {!isSubmitting && <Send size={18} />}
                                </button>

                                <p className="form-note">
                                    <MessageSquare size={14} /> {t('contact_form_note')}
                                </p>
                            </form>
                        )}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;
